module.exports = __webpack_public_path__ + "static/media/two.19a925f6.png";